module.exports = __webpack_public_path__ + "img/intro-01.6346b312.png";